module.exports = __webpack_public_path__ + "media/Step0.5947d1aa.webm";